import style from "../style.module.css";

interface CommentSectionProps {
  isApproving: boolean;
  onChange: (change: { comment: string }) => void;
  comment: string;
}

const CommentSection = ({
  isApproving,
  onChange,
  comment
}: CommentSectionProps) => {
  return (
    <div>
      <div className={style.commentLabel}>Leave a comment (optional)</div>
      <textarea
        className={style.textarea}
        placeholder={`I'm ${
          isApproving ? "approving" : "declining"
        } this design because…`}
        onChange={e => onChange({ comment: e.target.value })}
        value={comment}
      />
    </div>
  );
};

CommentSection.displayName = "CommentSection";

export default CommentSection;
